import React from 'react';

import {
  Button,
  Flexbox,
  FontAwesomeIcon,
  Text,
} from '@schoolinks/ui-components';

import cn from 'classnames';
import { bool } from 'prop-types';

import { useTranslation } from 'react-i18next';

import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';

import useCopyToClipboard from 'components/Common/TextCopy/useCopyToClipboard';
import Api from 'core/api';
import useFetch from 'hooks/useFetch';
import useMutation from 'hooks/useMutation';
import useUserRedux from 'hooks/useUserRedux';
import { ensureObject } from 'utils/objects';

import WalletVisibilitySwitch from 'modules/CredentialWallet/components/ListPageHeader/components/WalletVisibilitySwitch';

import s from './ListPageHeader.css';

const ListPageHeader = ({ isPublic }) => {
  const { t } = useTranslation();

  const publicLinkTooltip = t(
    'CredentialWallet.ListPageHeader.PublicLinkTooltip',
  );

  const { data: user } = useUserRedux();
  const { studentId } = ensureObject(user);

  const { copyToClipboard } = useCopyToClipboard({
    text: `${window.location.href}/${studentId}`,
  });

  const { data: profile } = useFetch({
    apiFunc: Api.studentProfile.getStudentProfile,
    apiFuncName: 'studentProfile.getStudentProfile',
    options: {
      enabled: !isPublic,
    },
  });
  const { isCredentialWalletPublic } = ensureObject(profile);

  const { mutateAsync: updateStudentProfile } = useMutation({
    apiFunc: Api.studentProfile.updateStudentProfile,
    apiFuncName: 'studentProfile.updateStudentProfile',
    invalidateQueries: ['studentProfile.getStudentProfile'],
  });

  return (
    <>
      <Flexbox
        className={s.headerContainer}
        justifyContent="space-between"
        width="100%"
      >
        <Flexbox
          className={cn(s.headerSection, s.headerSectionLeft)}
          width="15%"
        />
        <Flexbox
          alignItems="center"
          className={s.headerSection}
          flexDirection="column"
          rowGap={1}
          width="70%"
        >
          <Text align="center" variant="bodyReg400">
            {t('CredentialWallet.ListPageHeader.ADigitalRecordOfAcademicA')}
          </Text>
          <Button
            variant="text"
            label={t('CredentialWallet.ListPageHeader.LearnMore')}
            hasIconLeft
            icon={<FontAwesomeIcon icon={faQuestionCircle} />}
            href="https://support.schoolinks.com/en/articles/10671952-student-schoolinks-credential-wallet-guide"
          />
        </Flexbox>
        <Flexbox
          alignItems="flex-end"
          className={cn(s.headerSection, s.headerSectionRight)}
          flexDirection="column"
          rowGap={0.5}
          width="15%"
        >
          {!isPublic && (
            <WalletVisibilitySwitch
              isCredentialWalletPublic={isCredentialWalletPublic}
              updateStudentProfile={updateStudentProfile}
              publicLinkTooltip={publicLinkTooltip}
              copyToClipboard={copyToClipboard}
            />
          )}
        </Flexbox>
      </Flexbox>
    </>
  );
};

ListPageHeader.propTypes = {
  isPublic: bool,
};

ListPageHeader.defaultProps = {
  isPublic: false,
};

export default ListPageHeader;
